// extracted by mini-css-extract-plugin
export default {"button":"form_button__PpbF2","wrapper":"form_wrapper__cYXKv","a":"form_a__d+S2P","reset":"form_reset__sBaBa"};